import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

/**
 * 前台轮播图编辑弹窗 - 供拥有编辑权限的普通用户使用
 */
export default class ForumCarouselEditModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.itemCount = 3;
    this.items = [];
    this.uploading = false;
    this.uploadProgress = 0;
    this.loading = false;
    this.loadSettings();
  }

  loadSettings() {
    this.itemCount = parseInt(app.forum.attribute('custom-carousel-widget.item_count')) || 3;
    this.loadItems();
  }

  loadItems() {
    this.items = [];
    for (let i = 1; i <= this.itemCount; i++) {
      this.items.push({
        title: app.forum.attribute(`custom-carousel-widget.item_${i}_title`) || '',
        description: app.forum.attribute(`custom-carousel-widget.item_${i}_description`) || '',
        image: app.forum.attribute(`custom-carousel-widget.item_${i}_image`) || '',
        link: app.forum.attribute(`custom-carousel-widget.item_${i}_link`) || '',
      });
    }
  }

  className() {
    return 'ForumCarouselEditModal Modal--large';
  }

  title() {
    return app.translator.trans('tf-carousel-widget.forum.edit_modal_title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form-group">
          <label>{app.translator.trans('tf-carousel-widget.forum.edit_modal_item_count_label')}</label>
          <div className="helpText">
            {app.translator.trans('tf-carousel-widget.forum.edit_modal_item_count_help')}
          </div>
          <input
            className="FormControl"
            type="number"
            min="1"
            max="10"
            value={this.itemCount}
            oninput={(e) => this.updateItemCount(parseInt(e.target.value))}
          />
        </div>

        <div className="carousel-items">
          <h4>{app.translator.trans('tf-carousel-widget.forum.edit_modal_carousel_items')}</h4>
          {this.items.map((item, index) => (
            <div key={index} className="carousel-item-form">
              <div className="carousel-item-header">
                <h5>{app.translator.trans('tf-carousel-widget.forum.edit_modal_item', { number: index + 1 })}</h5>
                <div className="carousel-item-actions">
                  <Button
                    className="Button Button--small"
                    icon="fa-light fa-arrow-up"
                    disabled={index === 0}
                    onclick={() => this.moveItem(index, -1)}
                  >
                    {app.translator.trans('tf-carousel-widget.lib.move_up')}
                  </Button>
                  <Button
                    className="Button Button--small"
                    icon="fa-light fa-arrow-down"
                    disabled={index === this.items.length - 1}
                    onclick={() => this.moveItem(index, 1)}
                  >
                    {app.translator.trans('tf-carousel-widget.lib.move_down')}
                  </Button>
                </div>
              </div>

              <div className="Form-group">
                <label>{app.translator.trans('tf-carousel-widget.forum.edit_modal_item_title')}</label>
                <input
                  className="FormControl"
                  type="text"
                  value={item.title}
                  oninput={(e) => this.updateItem(index, 'title', e.target.value)}
                  placeholder={app.translator.trans('tf-carousel-widget.forum.edit_modal_item_title_placeholder')}
                />
              </div>

              <div className="Form-group">
                <label>{app.translator.trans('tf-carousel-widget.forum.edit_modal_item_description')}</label>
                <textarea
                  className="FormControl"
                  rows="3"
                  value={item.description}
                  oninput={(e) => this.updateItem(index, 'description', e.target.value)}
                  placeholder={app.translator.trans('tf-carousel-widget.forum.edit_modal_item_description_placeholder')}
                />
              </div>

              <div className="Form-group">
                <label>{app.translator.trans('tf-carousel-widget.forum.edit_modal_item_image')}</label>
                <div className="ImageUpload">
                  <input
                    type="file"
                    id={`forumImageInput_${index}`}
                    accept="image/*"
                    style="display: none;"
                    onchange={(e) => this.handleFileSelect(e, index)}
                  />
                  <div className="UploadArea">
                    {item.image ? (
                      <div className="ImagePreview">
                        <img
                          src={item.image}
                          style="max-width: 200px; max-height: 150px; border-radius: 4px; margin-bottom: 10px;"
                          onerror="this.style.display='none'"
                        />
                        <div className="ImageActions">
                          <Button
                            className="Button Button--primary Button--small"
                            onclick={() => document.getElementById(`forumImageInput_${index}`).click()}
                            disabled={this.uploading}
                          >
                            {app.translator.trans('tf-carousel-widget.forum.replace_image')}
                          </Button>
                          <Button
                            className="Button Button--danger Button--small"
                            onclick={() => this.removeImage(index)}
                            disabled={this.uploading}
                          >
                            {app.translator.trans('tf-carousel-widget.forum.remove_image')}
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="UploadPlaceholder">
                        <Button
                          className="Button Button--primary"
                          onclick={() => document.getElementById(`forumImageInput_${index}`).click()}
                          disabled={this.uploading}
                        >
                          {this.uploading
                            ? app.translator.trans('tf-carousel-widget.forum.uploading')
                            : app.translator.trans('tf-carousel-widget.forum.select_image')}
                        </Button>
                        <div className="Form-help">
                          {app.translator.trans('tf-carousel-widget.forum.upload_help')}
                        </div>
                      </div>
                    )}
                  </div>
                  {this.uploading && (
                    <div className="UploadProgress">
                      <div className="ProgressBar">
                        <div className="ProgressBar-fill" style={`width: ${this.uploadProgress}%`}></div>
                      </div>
                      <div className="ProgressText">{this.uploadProgress}%</div>
                    </div>
                  )}
                </div>
                <div className="Form-help" style="margin-top: 10px;">
                  {app.translator.trans('tf-carousel-widget.forum.or_enter_url')}
                </div>
                <input
                  className="FormControl"
                  type="url"
                  value={item.image}
                  oninput={(e) => this.updateItem(index, 'image', e.target.value)}
                  placeholder={app.translator.trans('tf-carousel-widget.forum.edit_modal_item_image_placeholder')}
                />
              </div>

              <div className="Form-group">
                <label>{app.translator.trans('tf-carousel-widget.forum.edit_modal_item_link')}</label>
                <input
                  className="FormControl"
                  type="url"
                  value={item.link}
                  oninput={(e) => this.updateItem(index, 'link', e.target.value)}
                  placeholder={app.translator.trans('tf-carousel-widget.forum.edit_modal_item_link_placeholder')}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="Modal-footer" style="margin-top: 20px; padding-top: 20px; border-top: 1px solid #e5e5e5;">
          <div style="display: flex; gap: 10px; justify-content: flex-end;">
            <Button
              className="Button Button--primary"
              onclick={() => this.save()}
              loading={this.loading}
              disabled={this.loading}
            >
              {app.translator.trans('tf-carousel-widget.forum.edit_modal_save')}
            </Button>
            <Button className="Button" onclick={() => this.hide()}>
              {app.translator.trans('tf-carousel-widget.forum.cancel')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  updateItemCount(newCount) {
    this.itemCount = Math.max(1, Math.min(10, newCount));
    this.loadItems();
    m.redraw();
  }

  updateItem(index, field, value) {
    this.items[index][field] = value;
    m.redraw();
  }

  moveItem(index, direction) {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= this.items.length) return;
    [this.items[index], this.items[newIndex]] = [this.items[newIndex], this.items[index]];
    m.redraw();
  }

  handleFileSelect(event, index) {
    const file = event.target.files[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tf-carousel-widget.forum.invalid_file_type'));
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tf-carousel-widget.forum.file_too_large'));
      return;
    }

    this.uploadFile(file, index);
  }

  uploadFile(file, index) {
    this.uploading = true;
    this.uploadProgress = 0;
    m.redraw();

    const formData = new FormData();
    formData.append('image', file);

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/carousel-widget/upload',
        body: formData,
        headers: {},
        onprogress: (event) => {
          if (event.lengthComputable) {
            this.uploadProgress = Math.round((event.loaded / event.total) * 100);
            m.redraw();
          }
        },
      })
      .then((response) => {
        if (response.success && response.path) {
          this.updateItem(index, 'image', response.path);
          app.alerts.show({ type: 'success' }, app.translator.trans('tf-carousel-widget.forum.upload_success'));
        } else {
          throw new Error('Upload response error');
        }
      })
      .catch((error) => {
        let errorMessage = app.translator.trans('tf-carousel-widget.forum.upload_failed');
        if (error.response && error.response.data && error.response.data.error === 'forbidden') {
          errorMessage = app.translator.trans('tf-carousel-widget.forum.upload_forbidden');
        }
        app.alerts.show({ type: 'error' }, errorMessage);
      })
      .finally(() => {
        this.uploading = false;
        this.uploadProgress = 0;
        m.redraw();
      });
  }

  removeImage(index) {
    this.updateItem(index, 'image', '');
    const fileInput = document.getElementById(`forumImageInput_${index}`);
    if (fileInput) fileInput.value = '';
    m.redraw();
  }

  save() {
    const settings = {};
    settings['custom-carousel-widget.item_count'] = this.itemCount.toString();

    this.items.forEach((item, index) => {
      const itemNum = index + 1;
      settings[`custom-carousel-widget.item_${itemNum}_title`] = item.title;
      settings[`custom-carousel-widget.item_${itemNum}_description`] = item.description;
      settings[`custom-carousel-widget.item_${itemNum}_image`] = item.image;
      settings[`custom-carousel-widget.item_${itemNum}_link`] = item.link;
    });

    for (let i = this.itemCount + 1; i <= 10; i++) {
      settings[`custom-carousel-widget.item_${i}_title`] = '';
      settings[`custom-carousel-widget.item_${i}_description`] = '';
      settings[`custom-carousel-widget.item_${i}_image`] = '';
      settings[`custom-carousel-widget.item_${i}_link`] = '';
    }

    this.loading = true;
    m.redraw();

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/carousel-widget/settings',
        body: settings,
      })
      .then(() => {
        app.alerts.show({ type: 'success' }, app.translator.trans('tf-carousel-widget.forum.edit_modal_saved'));
        // 刷新页面以显示更新后的轮播图
        window.location.reload();
      })
      .catch((error) => {
        this.loading = false;
        m.redraw();
        app.alerts.show({ type: 'error' }, app.translator.trans('tf-carousel-widget.forum.edit_modal_save_error'));
      });
  }
}
